export default "__VITE_ASSET__b500cd65__"